import { css } from '@emotion/css';

export const surveyEditorSidebarStyles = css`
  width: 34rem;
`;
